module.exports = __webpack_public_path__ + "img/banner-1.38b397c1.png";